import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30888fe5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_6 = { class: "dv-options" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign" }, "作答：", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  key: 0,
  class: "baq-question-analysis"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "baq-analysis-title" }, "解析:", -1))
const _hoisted_11 = ["innerHTML"]

import { onMounted, ref } from "vue";
import { ElInput } from "element-plus";
import useCompileContent from "@/hooks/useCompileContent";
import { unLock } from "@/utils/liner-lock";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
},
  setup(__props, { expose }) {

const props = __props


const { compileQuestionTitle } = useCompileContent();

const question = ref(props.question || {});
const content = ref(question.value?.answer_params?.content || "");
const getAnswer = () => {
  // 判断空格
  if (!/\s\S+|S+\s|\S/g.test(content.value)) {
    return { type: 0 };
  }
  if (!question.value.answer_params) {
    //* 没有回答过答案
    if (!content.value) {
      //* 内容一样 代表没有碰过答案
      return { type: 0 };
    }
    return {
      type: 1,
      answer_params: {
        content: content.value,
      },
    };
  } else {
    //* 回答过答案
    if (question.value.answer_params.content === content.value) {
      //*  跟之前答过的一样
      return { type: 0 };
    }
    return {
      type: 1,
      answer_params:
        content.value !== "" ? { content: content.value } : undefined,
    };
  }
};

// * 标题编译
const questionTitle = ref<HTMLDivElement>();
compileQuestionTitle(questionTitle, question.value.title || "");
expose({ getAnswer });

onMounted(() => {
  unLock();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(question.value.indexInQuestion !== undefined
            ? question.value.indexInQuestion + "."
            : "") + _toDisplayString(question.value.titleNum > 0 ? question.value.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        innerHTML: question.value.title,
        id: "dvCompile",
        class: "dv-title",
        ref_key: "questionTitle",
        ref: questionTitle
      }, null, 8, _hoisted_4),
      (props.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (" + _toDisplayString(question.value.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(ElInput), {
          modelValue: content.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
          disabled: props.disabled,
          rows: 8,
          type: "textarea",
          placeholder: "请输入答案",
          clearable: "",
          autofocus: "",
          "show-word-limit": ""
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", {
            class: "baq-analysis-content",
            innerHTML: question.value?.analysis || ''
          }, null, 8, _hoisted_11)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})